a = b = c = 0
running = false
$window = $(window)
$body = $('body')

@reveal = (evt) ->
  scrollAmount = evt.originalEvent.wheelDelta

  if scrollAmount > 0 and (running or $window.scrollTop() <= 0)
    # If we're upscrolling and at the top of the page, do work.
    # Prevent native OSX overscroll by preventing default.
    evt.preventDefault()

    running = true

    # Sometimes the scroll amount can jump back and forth. For example:  [1,  2,  3,  4,  *2*,  5,  4,  3,  2,  1]
    # If this happens, we should omit the "2" in position 5 as erroneous, so only scroll if "same direction".
    $body.css 'transform', "translate3d(0, #{scrollAmount}px, 0)" if sameDirection(scrollAmount)

  else
    reset() if running

sameDirection = (scrollAmount) ->
  # Shift values using simple vars. This appears to be the most performant method.
  # Proof: http://jsperf.com/shift-push-vs-unshift
  a = b;  b = c; c = scrollAmount
  (a <= b and b <= c) or (a >= b and b >= c)

reset = ->
  a = b = c = 0
  running = false
  $body.css 'transform', 'translate3d(0, 0, 0)'
